import { Box, CircularProgress, Typography } from '@mui/material';
import { fonts } from '../../theme/typography';

interface ModalLoadingProps {
  loadingTitle?: string;
}
export const ModalLoading: React.FC<ModalLoadingProps> = ({ loadingTitle }) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      {loadingTitle && (
        <Typography variant="large" component="h6" fontFamily={fonts.heading} fontWeight="Bold">
          {loadingTitle}
        </Typography>
      )}
      <Box sx={{ mt: 7.5 }}>
        <CircularProgress sx={{ m: 1 }} size={120} />
      </Box>
    </Box>
  );
};
